import Lara from "@/presets/lara";

export const modalPresets = {
  ...Lara,
  dialog: {
    ...Lara.dialog,
    header: {
      class: [
        "flex",
        "items-center",
        "justify-between",
        "h-14",
        "p-2",
        "px-4",
        "border-t-0",
        "bg-teal-accent",
        "rounded-t-lg",
        "font-semibold",
      ],
    },
    closeButton: { class: ["mt-1"] },
    closeButtonIcon: { class: ["text-black"] },
  },
};
